import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=5ff8ebf3&scoped=true&lang=html&"
import script from "./purchase.vue?vue&type=script&lang=js&"
export * from "./purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff8ebf3",
  null
  
)

export default component.exports